// extracted by mini-css-extract-plugin
export default {"container":"burger-page_container__kOWWR"};